import styled from 'styled-components';

export const TextMessage = styled.div`
  word-wrap: break-word;
`;

export const MarkdownWrapper = styled.div`
  ol + ul {
    margin-left: 15px;
  }
`;
